module.exports = __webpack_public_path__ + "img/interaction-wh-response-time.ab9b4d24.png";